// extracted by mini-css-extract-plugin
module.exports = {"grid":"block_grid__XcmN3","logo":"block_logo__f1RxR","image":"block_image__N46Sb"};